import { useState } from "react";
import { useAuth } from "./AuthContext";
import { FiLogOut } from 'react-icons/fi';
import { Modal, Button } from "react-bootstrap";

const Logout = () => {
  const { logout } = useAuth();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleLogout = () => {
    setShowConfirmation(true);
  };

  const handleConfirmLogout = () => {
    logout();
    setShowConfirmation(false);
  };

  const handleCancelLogout = () => {
    setShowConfirmation(false);
  };

  return (
    <>
      <style>
        {`
          .modern-logout-button {
            background: rgba(244, 63, 94, 0.15);
            border: 1px solid rgba(244, 63, 94, 0.3);
            border-radius: 8px;
            padding: 7px 14px;
            color: #fda4af;
            font-weight: 600;
            font-size: 13px;
            cursor: pointer;
            display: flex;
            align-items: center;
            gap: 6px;
            transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            backdrop-filter: blur(10px);
            position: relative;
            overflow: hidden;
          }

          .modern-logout-button::before {
            content: '';
            position: absolute;
            top: 0;
            left: -100%;
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(244, 63, 94, 0.25), transparent);
            transition: left 0.5s;
          }

          .modern-logout-button:hover::before {
            left: 100%;
          }

          .modern-logout-button:hover {
            background: rgba(244, 63, 94, 0.25);
            border-color: rgba(244, 63, 94, 0.4);
            box-shadow: 0 4px 15px rgba(244, 63, 94, 0.15);
            color: #fff;
            transform: translateY(-1px);
          }

          .modern-logout-button:active {
            transform: translateY(1px);
            box-shadow: none;
          }

          .logout-icon {
            font-size: 15px;
            transition: transform 0.3s ease;
          }

          .modern-logout-button:hover .logout-icon {
            transform: translateX(2px);
          }

          .modern-modal .modal-content {
            background: #ffffff;
            border: 1px solid rgba(0, 0, 0, 0.1);
            border-radius: 16px;
            color: #0f172a;
            box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
          }

          .modern-modal .modal-header {
            border-bottom: 1px solid rgba(0, 0, 0, 0.05);
            padding: 20px 24px;
          }

          .modern-modal .modal-title {
            font-weight: 600;
            font-size: 18px;
            color: #0f172a;
            letter-spacing: 0.5px;
          }

          .modern-modal .modal-body {
            padding: 24px;
            font-size: 15px;
            color: #475569;
          }

          .modern-modal .modal-footer {
            border-top: 1px solid rgba(0, 0, 0, 0.05);
            padding: 16px 24px;
            gap: 12px;
          }

          .modern-modal .btn-close {
            filter: invert(0) opacity(0.5);
            transition: all 0.2s;
          }

          .modern-modal .btn-close:hover {
            filter: invert(0) opacity(1);
          }

          .modern-cancel-btn {
            background: rgba(0, 0, 0, 0.04) !important;
            border: 1px solid rgba(0, 0, 0, 0.1) !important;
            color: #475569 !important;
            padding: 8px 20px !important;
            border-radius: 8px !important;
            font-weight: 500 !important;
            transition: all 0.3s ease !important;
          }

          .modern-cancel-btn:hover {
            background: rgba(0, 0, 0, 0.08) !important;
            border-color: rgba(0, 0, 0, 0.15) !important;
            color: #0f172a !important;
          }

          .modern-confirm-btn {
            background: rgba(225, 29, 72, 0.9) !important;
            border: 1px solid #be123c !important;
            color: white !important;
            padding: 8px 20px !important;
            border-radius: 8px !important;
            font-weight: 500 !important;
            transition: all 0.3s ease !important;
          }

          .modern-confirm-btn:hover {
            background: #be123c !important;
            box-shadow: 0 4px 15px rgba(225, 29, 72, 0.25) !important;
          }

          @media (max-width: 480px) {
            .modern-logout-button {
              padding: 6px 12px;
              font-size: 12px;
            }

            .logout-icon {
              font-size: 14px;
            }
          }
        `}
      </style>

      <button onClick={handleLogout} className="modern-logout-button">
        <FiLogOut className="logout-icon" />
        <span>Logout</span>
      </button>

      <Modal 
        show={showConfirmation} 
        onHide={handleCancelLogout}
        centered
        className="modern-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Logout Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to logout?</Modal.Body>
        <Modal.Footer>
          <Button className="modern-cancel-btn" onClick={handleCancelLogout}>
            Cancel
          </Button>
          <Button className="modern-confirm-btn" onClick={handleConfirmLogout}>
            Logout
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Logout;
